<template>
  <div class="firm-intro">
    <table class="firm-content" border="0" cellspacing="0" cellpadding="0">
      <tr
        v-for="(item, index) in data"
        :key="index"
        :class="item.line == '0' ? 'tr-singular' : ''"
      >
        <th class="th-one">{{ item.title1 }}</th>
        <th class="th-twe">
          {{ item.content1 }}
        </th>
        <th class="th-three">{{ item.title2 }}</th>
        <th class="th-four">
          {{ item.content2 }}
        </th>
      </tr>
      <tr class="tr-singular">
        <th class="th-one">企业地址</th>
        <th class="th-twe" colspan="3">
          河南省南阳市卧龙区七一街道工业南路兴达商务6楼P室
        </th>
      </tr>
      <tr>
        <th class="th-one">经营范围</th>
        <th class="th-twe th-twe-Radius" colspan="3">
          一般项目：软件开发；网络与信息安全软件开发；信息技术咨询服务；软件销售；数字文化创意软件开发；人工智能应用软件开发；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）
        </th>
      </tr>
      <tr class="tr-singular">
        <th class="th-one">附加服务</th>
        <th class="th-twe" colspan="3">——</th>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [
        {
          title1: "法定代表人(负责人)",
          content1: "张三",
          title2: "纳税人识别号",
          content2: "91411303MADLQ4AT3L",
          line: "0", // 表格颜色
        },
        {
          title1: "名称",
          content1: "xxx科技有限公司",
          title2: "机构代码",
          content2: "MADLQ4AT3",
          line: "1",
        },
        {
          title1: "注册号",
          content1: "--",
          title2: "注册资本",
          content2: "100万人民币",
          line: "0",
        },
        {
          title1: "统一信用代码",
          content1: "91411303MADLQ4AT3L",
          title2: "登记机关",
          content2: "南阳市市场监督管理局",
          line: "1",
        },
        {
          title1: "经营状态",
          content1: "存续",
          title2: "成立日期",
          content2: "2024-06-07",
          line: "0",
        },
        {
          title1: "企业类型",
          content1: "有限责任公司(自然人投资或控股)",
          title2: "经营期限",
          content2: "2024-06-07 至 永续经营",
          line: "1",
        },
        {
          title1: "所属地区/邮编",
          content1: "河南 卧龙区      473000",
          title2: "核准日期",
          content2: "2024-06-07",
          line: "0",
        },
        {
          title1: "年度工商报",
          content1: "2024-06-07(到期时间)",
          title2: "税务年度汇算清缴",
          content2: "2024-06-07(到期时间)",
          line: "1",
        },
      ],
    };
  },
  watch: {},
  components: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="less">
.firm-intro {
  width: 100%;
  height: 100%;
  background: #ffffff;
  border-radius: 5px;
  margin-top: 30px;
  display: flex;
  .firm-content {
    width: 100%;
    min-height: 40px;
    border: 1px solid #eeeeee;
    .tr-singular {
      background: #eeeeee;
    }
    th {
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #333333;
      text-align: right;
      font-weight: 400;
      height: 40px;
      position: relative;
    }
    .th-one {
      width: 130px;
      padding-right: 10px;
      border-right: 1px solid gray;
    }
    .th-twe {
      width: 350px;
      text-align: left;
      text-indent: 10px;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #666666;
      font-weight: 400;
    }
    .th-three {
      width: 150px;
      padding-right: 10px;
      border-left: 1px solid gray;
      border-right: 1px solid gray;
    }
    .th-four {
      text-align: left;
      text-indent: 10px;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #666666;
      font-weight: 400;
    }
    .th-twe-Radius {
      line-height: 22px;
      text-indent: 0px;
      padding: 10px;
    }
    .help {
      position: absolute;
      right: 10px;
      top: 10px;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #409eff ;
      font-weight: 400;
    }
  }
}
</style>
